import { Dialog, DialogContent, Typography } from '@mui/material';
import type { ReactNode } from 'react';

import { BoxFlex } from '@woovi/ui';

import useStoreContext from '../store/useStoreContext.tsx';

export type PixErrorProps = {
  error: string;
};
export const PixError = ({ error }: PixErrorProps): ReactNode => {
  return (
    <BoxFlex
      sx={{
        alignItems: 'center',
        flexDirection: 'column',
        pb: '10px',
        p: '20px',
      }}
    >
      <Typography>Error</Typography>
      <Typography>{error}</Typography>
    </BoxFlex>
  );
};

export type PixErrorDialogProps = {
  isOpen: boolean;
  onClose: (isOpen: boolean) => void;
  error: string;
};

const PixErrorDialog = ({
  isOpen = true,
  onClose,
  error,
}: PixErrorDialogProps): ReactNode => {
  const { openPixState } = useStoreContext();

  if (!openPixState.modal) {
    return <PixError error={error} />;
  }

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogContent>
        <PixError error={error} />
      </DialogContent>
    </Dialog>
  );
};

export default PixErrorDialog;
